import styles from "./index.css";
import PropTypes from "prop-types";
import classnames from "classnames";
import Banner from "../../common/Banner";
import { TICK } from "../Banners/constants";

const SuccessBanner = ({ successMessage, className, render }) => (
  <Banner
    ariaLive="polite"
    className={classnames(styles.successBanner, styles.show, className)}
    message={successMessage}
    outerContent={render}
    iconClass={TICK}
  />
);

SuccessBanner.propTypes = {
  successMessage: PropTypes.string.isRequired,
  className: PropTypes.string,
  render: PropTypes.func
};

export default SuccessBanner;
